import SlaughterHouseApi from '../../../api/person/slaughterHouseApi';

export default {
  namespaced: true,
  states: {

  },
  mutations: {

  },
  actions: {
    async fetchAll() {
      try {
        const reponse = await SlaughterHouseApi.fetchAll();
        return Promise.resolve(reponse.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async fetch(_, { id }) {
      try {
        const reponse = await SlaughterHouseApi.fetch(id);
        return Promise.resolve(reponse.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async create({dispatch}, { form }) {
      try {
        const reponse = await SlaughterHouseApi.create(form);
        dispatch('NOTIFY_MSG', 'slaughter.notification.save', {root: true});
        return Promise.resolve(reponse.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async addOrUpdateTransport({dispatch}, {id, form }) {
      try {
        const reponse = await SlaughterHouseApi.addOrUpdateTransport(id, form);
        dispatch('NOTIFY_MSG', 'slaughter.notification.save', {root: true});
        return Promise.resolve(reponse.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetchTransport({dispatch}, { slaughterHouseId }) {
      try {
        const reponse = await SlaughterHouseApi.fetchTransport(slaughterHouseId);
        return Promise.resolve(reponse.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async fetchSlaughterAvailableDeliverProgram({dispatch}, { slaughterId }) {
      try {
        const reponse = await SlaughterHouseApi.fetchAvailableDeliveryPrograms(slaughterId);
        return Promise.resolve(reponse.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async addSlaughterAvailableDeliverProgram({dispatch}, form) {
      try {
        const reponse = await SlaughterHouseApi.addAvailableDeliveryPrograms(form);
        dispatch('NOTIFY_MSG', 'slaughter.notification.save', {root: true});
        return Promise.resolve(reponse.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    },
    async deleteSlaughterAvailableDeliverProgram({dispatch}, form) {
      try {
        const reponse = await SlaughterHouseApi.deleteAvailableDeliveryPrograms(form);
        dispatch('NOTIFY_MSG', 'slaughter.notification.save', {root: true});
        return Promise.resolve(reponse.data);
      } catch (error) {
        await dispatch('NOTIFY_ERROR', error, {root: true});
        return Promise.reject(error);
      }
    }
  }
}
